import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import cookie from 'react-cookies';
import Swal from 'sweetalert2';
import RingLoader from 'react-spinners/RingLoader';
import Helmet from 'react-helmet';
import { permissionTypes } from 'drapcode-constant';
import 'react-toastify/dist/ReactToastify.css';
import 'react-dropzone-uploader/dist/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-intl-tel-input/dist/main.css';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import logo from '../../images/drapcode-logo-white.svg';
import DefaultPage from '../tutorial/DefaultPage';
import TopNav from '../../common/TopNav';
import SideBar from './sidebar/SideBar';
import ItemDetail from '../collections/item/ItemDetail';
import '../../webconnect';
import { Mixpanel } from '../../common/utils/mixpanelUtil';
import { updateUserIpInCookie } from '../../common/utils/api_utils';
import { resetCookie, saveCookie } from '../../common/utils/check-auth';
import Shortcut from '../../shortcut/Shortcut';

const css = {
  margin: 'auto',
  marginTop: '15%',
  display: 'block',
};

const homeAppStyle = {
  height: '100%',
};

const imageStyle = {
  display: 'block',
  height: '30px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '5px',
  zIndex: 10,
  position: 'relative',
};

const divImageStyle = {
  display: 'block',
  position: 'absolute',
  backgroundColor: '#303453', // darken(@builder-base-color, 10%)
  width: '100%',
  zIndex: 4,
};
const toastrStyle = {
  width: 'auto',
  minWidth: '15vw',
};

const alertOptions = {
  allowOutsideClick: false,
  allowEscapeKey: false,
  allowEnterKey: false,
  icon: 'error',
  title: 'Oops...',
};
export class App extends Component {
  static propTypes = {
    children: PropTypes.node,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    showLoader: false,
    showContent: false,
  };

  static defaultProps = {
    children: '',
  };

  async componentDidMount() {
    const { location, actions } = this.props;
    const path = location.pathname;
    const extractPath = path.split(/[/]/);
    const version = extractPath[2];
    const projectId = extractPath[4];

    const orgSurfaceUrl = process.env.REACT_APP_ORGANIZATION;
    const orgEngineUrl = process.env.REACT_APP_ORGANIZATION_ENGINE;
    if (!projectId) {
      window.location.href = `${orgSurfaceUrl}`;
    }
    this.setState({ showLoader: true });
    if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
      this.setState({ showLoader: false, showContent: true });
      await actions.loadProjectDetail({ projectId, version });
      await actions.loadInstalledPlugin({ projectId, version });
      await actions.loadProjectVersion({ projectId });
    } else {
      let config = {
        headers: {
          Authorization: `Bearer ${cookie.load('token')}`,
        },
      };
      const clientDetailUrl = `${orgEngineUrl}clients/details/${projectId}/project`;
      axios
        .get(clientDetailUrl, config)
        .then(async (response) => {
          let { status, message, user, organization, role } = response.data;
          if (status === 'FAILED') {
            resetCookie();
            Swal.fire({
              ...alertOptions,
              text: message,
              confirmButtonText: 'Try Again',
              footer: `<a href="${orgSurfaceUrl}contact-us">Why do I have this issue?</a>`,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = `${orgSurfaceUrl}`;
              }
            });
            this.setState({ showLoader: false });
            return;
          } else if (status === 'SUCCESS') {
            await actions.loadProjectDetail({ projectId, version });
            await actions.loadInstalledPlugin({ projectId, version });
            await actions.loadProjectVersion({ projectId });
            if (role === 'ROLE_ADMIN') {
              organization = { permissions: permissionTypes, subscription: 'UNLIMITED' };
            }
            saveCookie(user, organization);
            this.setState({ showLoader: false, showContent: true });
          } else {
            window.location.href = orgSurfaceUrl;
            resetCookie();
            this.setState({ showLoader: false });
            return;
          }
        })
        .catch((err) => {
          console.log('err :>> ', err);
          resetCookie();
          this.setState({ showLoader: false });
          if (err && err.response && err.response.status === 401) {
            Swal.fire({
              ...alertOptions,
              text: 'Your have been logged out due to inactivity. Please login again.',
              confirmButtonText: 'Login',
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = `${orgSurfaceUrl}`;
              }
            });
          }
          window.location.href = `${orgSurfaceUrl}`;
          return;
        });
    }

    const userIp = cookie.load('userIp');
    if (!userIp) {
      await updateUserIpInCookie();
    }
    const lastAccess = cookie.load('lastAccess');
    if (!lastAccess) {
      await actions.addLastAccess({ projectId });
    }
  }

  showTopNav = () => {
    const { location, common, actions } = this.props;
    const { projectDetail, versions } = common;
    const path = location.pathname;
    const extractPath = path.split(/[/]/);
    const version = extractPath[2];
    const projectId = extractPath[4];

    if (projectId) {
      return (
        <Fragment>
          <TopNav
            projectId={projectId}
            actions={actions}
            projectDetail={projectDetail}
            version={version}
            versions={versions}
            location={location}
          />
        </Fragment>
      );
    }
  };

  showBuilder = () => {
    const { location } = this.props;
    const path = location.pathname;
    const extractPath = path.split(/[/]/);
    const version = extractPath[2];
    const projectId = extractPath[4];

    if (projectId) {
      return (
        <Fragment>
          <Shortcut projectId={projectId} version={version} />
          <SideBar projectId={projectId} version={version} />
          <DefaultPage />
          <ItemDetail projectId={projectId} version={version} />
        </Fragment>
      );
    }
  };

  render() {
    const { location, children, common } = this.props;
    const path = location.pathname;
    const { showLoader, showContent } = this.state;
    const { projectDetail } = common;
    if (showLoader) {
      return <RingLoader css={css} size="80px" color={'#1d1d1d'} loading={showLoader} />;
    }

    if (path === '/login' || path === '/') {
      return <div className="layout-container">{children}</div>;
    } else if (projectDetail && projectDetail.isDeleted) {
      return (
        <div className="page-container bg-blue-grey-900 pt-2">
          <h1 style={{ textAlign: 'center' }}>This project has been deleted.</h1>
        </div>
      );
    } else {
      return (
        <div className="home-app" style={homeAppStyle}>
          <Helmet>
            <title>DrapCode | Build Awesome Web Applications</title>
          </Helmet>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            style={toastrStyle}
          />
          <div style={divImageStyle}>{this.showTopNav()}</div>
          {this.showBuilder()}
          {children}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
